export default [
  {
    id: "01",
    storename: "Harsh Dedhia",
    storeemail: "harsh@gmail.com",
    rating: "850",
    pendingreview: "Enabled",
    reviewcount: "3.8/5"
  },
  {
    id: "02",
    storename: "Sumit Jaiswal",
    storeemail: "sumit@gmail.com",
    rating: "10",
    pendingreview: "Enabled",
    reviewcount: "3.8/5"
  },
  {
    id: "03",
    storename: "Mohnish Thandassery",
    storeemail: "mohnish@gmail.com",
    rating: "17",
    pendingreview: "Disabled",
    reviewcount: "3.8/5"
  }
];
